import { googleReserve, involveAsia, utm } from "@/services/referrer";

function getUTMSource() {
  const defaultUtmSource = "web";
  const { get: getGoogleReserve } = googleReserve();
  const { get: getInvolveAsiaClickId } = involveAsia();
  const { get: getUtm } = utm();
  const { utmMedium, utmSource, utmVersion } = getUtm();
  const involveAsiaClickId = getInvolveAsiaClickId();
  const googleReserveToken = getGoogleReserve();
  let selectedUtm = "";
  if (
    typeof utmVersion === "string" &&
    utmVersion === "v2" &&
    typeof utmMedium === "string" &&
    utmMedium.length
  ) {
    selectedUtm = utmMedium;
  } else {
    selectedUtm = utmSource;
  }
  if (typeof involveAsiaClickId === "string" && involveAsiaClickId.length > 0) {
    return "InvolveAsia";
  }
  if (typeof googleReserveToken === "string" && googleReserveToken.length > 0) {
    return "rwg";
  }
  return typeof selectedUtm === "string" && selectedUtm.length
    ? selectedUtm
    : defaultUtmSource;
}

export { getUTMSource };
